import type { NextPage } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";

import PageHead from "~/components/common/PageHead";
import MobilePage from "~/components/me/page/MobilePage";
import PcPage from "~/components/me/page/PcPage";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";
import { Layout } from "~/lib/client/layout";
import { useActivityLogger } from "~/lib/client/logger/useActivityLogger";
import { useAppContext } from "~/pages/_app";

const pageName = "dashboard";

const MePage: NextPage = () => {
  const isSpMode = useIsSpMode();
  const router = useRouter();
  const sendActivityLog = useActivityLogger();
  const Page = isSpMode ? MobilePage : PcPage;
  const { currentUser } = useAppContext();

  // ログインしてなかったらログイン画面に飛ばす
  useEffect(() => {
    if (typeof currentUser === "undefined") return;
    if (typeof isSpMode === "undefined") return;

    (async () => {
      if (!currentUser) {
        try {
          await router.replace("/account/login");
        } catch (err) {
          console.error(err);
        }
        return;
      }
    })();
  }, [currentUser, router, isSpMode]);

  useEffect(() => {
    if (!currentUser) return;
    if (sendActivityLog === undefined) return;

    (async () => {
      await sendActivityLog({
        actionName: "show",
        pageName,
      });
    })();
  }, [sendActivityLog, currentUser]);

  if (
    typeof currentUser === "undefined" || // ログイン状態の確認ができていない
    typeof isSpMode == "undefined" // 初期状態
  )
    return (
      <>
        <PageHead />
      </>
    );

  return (
    <>
      <PageHead />
      <Layout layoutType={"YTLayout"}>
        {currentUser?.id === 1 && <Link href="/admin">管理者はこちら</Link>}
        <Page />
      </Layout>
    </>
  );
};

export default MePage;
